/* 🤖 this file was generated by svg-to-ts */
export const matIconReply: {
  name: 'reply';
  data: string;
} = {
  name: 'reply',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/></svg>`
};
